<template>
  <div>
    <h3 class="text-lg font-[500] mb-4">All Available Routes</h3>
    <div v-loading="loading">
      <div v-for="route in routes" :key="route.id" class="flex gap-3 items-center py-2 my-1">
        <base-checkbox @change="changedValue($event, route)" />
        <span>{{ route && route.routeName ? route.routeName.replace('-', " to ") : '' }}</span>
      </div>


      <div class="flex justify-end mt-5">
        <base-button text="Next" @click="proceed" :loading="loading" :disabled="disabled" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  activated() {
    this.getRoutes()
  },
  mounted() {
    this.getRoutes()
  },
  computed: {
    disabled() {
      return this.selectedRoute.length < 1
    }
  },
  data() {
    return {
      routes: [],
      selectedRoute: [],
      loading: false
    }
  },
  methods: {
    proceed() {
      this.$store.dispatch('setNewConsolidationSelecetedRoutes', this.selectedRoute);
      this.$store.dispatch('setNewConsolidationLevel', 2)
    },
    changedValue(checked, route) {
      checked && this.selectedRoute.push(route?.id)
      if (!checked) {
        this.selectedRoute = this.selectedRoute.filter((item) => item !== route?.id)
      }
    },
    async getRoutes() {
      this.loading = true;
      try {
        let response = await this.$_newGetConsolidationRoutes()
        this.routes = response?.data?.data?.routes
      } catch (error) {
        // ...code here
      } finally {
        this.loading = false;
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.checkbox {
  display: initial;
  width: 1.2rem;
  height: 1.2rem;
  @apply accent-primary-yellow
}

.checkbox:checked {
  @apply bg-primary-yellow
}
</style>